<script context="module">
    import { env } from '../Environment.svelte';

    export async function uploadDocuments(
        accountNumber,
        accountId,
        fileName,
        fileExtension,
        data
    ) {
        var UPLOAD_DOCUMENTS_ENDPOINT =
            env[env.stage].api.url + 'izziuxp-web-oc/v1/api/attachFiles';
        var headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('Authorization', env[env.stage].apiFiles.key);

        let requestOptions = {
            method: 'POST',
            headers: headers,
            redirect: 'follow',
            body: JSON.stringify({
                accountNumber: accountNumber,
                accountId: accountId,
                file: {
                    fileName: fileName,
                    fileExtension: fileExtension,
                    data: data,
                },
            }),
        };

        const response = fetch(UPLOAD_DOCUMENTS_ENDPOINT, requestOptions)
            .then((response) => response.json())
            .then((result) => result);
        return await response;
    }
</script>
